import { AxiosError } from 'axios';
import { GET_EXAM_CONFIGURATION_EXAM_TYPE_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { GET_EXAM_CONFIGURATION_EXAM_TYPE_URL } from '../../constants/apiUrls';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ExamTypeModel {
  code: string;
  description: string;
  aeisExam: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetExamType = ({ onSuccess, onError }: Input = {}) => {
  const getExamType = async () => {
    const res = await axiosClient.get<ExamTypeModel[]>(GET_EXAM_CONFIGURATION_EXAM_TYPE_URL);
    return res.data;
  };

  return useCustomQuery(GET_EXAM_CONFIGURATION_EXAM_TYPE_QUERY_KEY, getExamType, {
    onSuccess,
    onError,
  });
};
